import React from 'react';
import PropTypes from "prop-types";
import Profile from './Profile';
import {connect} from 'react-redux';
import NoOfferFound from "../common/NoOfferFound";
import {iconCheck} from "../common/Icon";

const propTypes = {
	offer: PropTypes.object,
};

const defaultProps = {
	offer: undefined,
};

const mapStateToProps = (state) => {
	return {
		offer: state.app.offer
	};
};

class FirstDay extends React.Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		window.scrollTo(0,0);
	}

	render() {
		return (
			<React.Fragment>
				{this.props.offer && this.props.offer.guid ?
				<div>
					<Profile/>
					<section>
						<h2 className="headline">First Day of Work</h2>
						<div className="content">
							<span className="offer-accepted-block">{iconCheck()} Offer accepted</span>
							<p><b>Your First Day of Work</b></p>
							<p>For verification of your right to work in the United States, please bring original documents (not copies) that will establish your identity and employment authorization. <a href="https://www.uscis.gov/i-9-central/acceptable-documents/list-documents/form-i-9-acceptable-documents" target="_blank">Click here</a> for a list of approved documents.</p>
							<p>The State of Utah, Executive Branch, participates in the Federal Employment Verification Program (E-Verify). Information from each new hire's I-9 will be provided to the Social Security Administration and, if necessary, the Department of Homeland Security. Continued employment for all new hires will be contingent on confirmation of employment eligibility through the E-Verify Program.</p>
							<p>Please bring your Social Security card (not a copy), which we will use to ensure accurate payroll tax and Social Security contributions.</p>

							<p>{this.props.offer.otherInfoText}</p>


							<p><b>On-boarding Tour</b></p>
							<p>Shortly after accepting this offer of employment, you will be notified via your personal email account of how to access the State's employee onboarding program. In this program, you will update and provide additional personal information, acknowledge important state policies, and be given further information about your new employment with the State of Utah.</p>

                            {this.props.offer.criminalHistoryCheckText ?
                                <div>
									<p><b>Criminal History</b></p>
									<p> {this.props.offer.criminalHistoryCheckText}</p>
								</div> : undefined
							}

                            {this.props.offer.drugTestingText ?
                                <div>
									<p><b>Drug Testing</b></p>
									<p> {this.props.offer.drugTestingText}</p>
								</div> : undefined
							}

                            {this.props.offer.licenseText ?
                                <div>
									<p><b>Licensees / Certification </b></p>
									<p> {this.props.offer.licenseText}</p>
                                </div> : undefined
							}

							<p><b>Disclaimer</b></p>
							<p>This document constitutes an offer of employment with the State of Utah only; it does not create a contract, express or implied, regarding the terms and conditions of employment, which are established by state and federal law, Department of Human Resource Management rules, and agency policy.</p>
						</div>
					</section>
				</div> : <NoOfferFound/>}
			</React.Fragment>
		);
	}
}

FirstDay.propTypes = propTypes;
FirstDay.defaultProps = defaultProps;

export default connect(mapStateToProps)(FirstDay);